<template>
    <div :class="[`backdrop ${isOpenSuccessBlock ? 'show-backdrop' : ''}`]" @click="$emit('on-backdrop-click')">
        <div :class="[`main-success-modal-block ${isOpenSuccessBlock ? 'open-payment-info-block' : ''}`]">
            <div class="success-icon-block">
                <check-icon class="success-icon" />
            </div>
            <p class="success-title">{{ $t('homePage.successDelete') }}</p>
            <p class="success-text">{{ $t('homePage.successDeleteDeskr') }}</p>
            <button @click="$emit('on-backdrop-click')" class="success-button">{{ $t('homePage.okay') }}</button>
        </div>

    </div>
</template>

<script>

import {  
  CheckIcon
} from 'vue-feather-icons';

export default {
    name: "Success-block",
    components: {
        CheckIcon
    },
    props: {
        isOpenSuccessBlock: {
            type: Boolean,
            require: true
        },
        isEdit: {
            type: Boolean,
            require: true
        },
        isSuccessDelete: {
            type: Boolean,
            require: false
        }
    },
    data() {
        return {
        }
    },
    async mounted() {

    },

    methods: {

    },
    computed: {

    },
    watch: {

    }
}
</script>

<style scoped>
.main-success-modal-block {
    position: absolute;
    width: 70%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    opacity: 0;
    pointer-events: all !important;
    -webkit-backdrop-filter: saturate(180%) blur(80px);
    backdrop-filter: saturate(180%) blur(80px);
    background-color: rgba(255, 255, 255, 0.8);
    pointer-events: none;
    z-index: 0 !important;
    border: 0px !important;
    border-radius: 20px;
    transition: all .5s ease;
}

.open-payment-info-block {
  opacity: 1;
  z-index: 9999 !important;
}

.success-icon-block {
    margin: 0 auto;
    width: 50px;
    height: 50px;
    background: var(--secondary-bg-color);
    border-radius: 50%;
    display: flex;
}
.success-icon {
    color: #fff;
    width: 40px;
    height: 40px;
    margin: auto;
}
.success-title {
    color: #1b1b1b;
    font-family: "Source Sans 3", sans-serif;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: -0.6px;
    font-size: 19px;
    text-align: center;
    margin-top: 20px;
}
.success-text {
    text-align: center;
    color: #393939;
    font-family: "Source Sans 3", sans-serif;
    line-height: 20px;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0px;
}
.success-button {
    position: relative;
  font-family: "Source Sans 3", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  width: 100%;
  color: #FFF;
  font-size: 12px;
  margin-top: 20px;
  padding: 12px 18px;
  border: none;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  background-image: var(--main-bg-color);;
  cursor: pointer;
}
.success-button::after {
     content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: inherit;
    z-index: -1;
    transform: scale(0.75) translateY(5px) translateZ(0px);
    filter: blur(8px);
}
</style>